module.exports = __webpack_public_path__ + "static/media/00_1440.3edcb765.jpeg";